import countries from "./external_data";

export const process_country = (key = false) => {
    // If no subset is selected, return plain json data
    if (!(key)){return countries;}
    // Else, sum up data of all countries and return selected subset
    let result={};
    result[key] = {};
    for (const country in countries) {
        for (const property in countries[country][key]){
            if (!(result[key].hasOwnProperty(property))){
                result[key][property] = 0;
            }
            result[key][property] += countries[country][key][property];
        }
    }
    return result[key];
};



// WEBPACK FOOTER //
// ./src/views/Pages/Homepage/helper.js